require('react-app-polyfill/ie11')
require('./arrayFind')
require('./arrayFindIndex')
require('./arrayIncludesPolyfill')
require('./domAppendPolyfill')
require('./nodeListForEachPolyfill')
require('./stringRepeatPolyfill')
require('./stringStartsWithPolyfill')
